module.exports = __webpack_public_path__ + "img/Jozef_Ostyn.f7ab2bb4.jpg";